import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.m.scss';

const propTypes = {
  className: PropTypes.string,
  percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  small: PropTypes.bool,
};

const Progress = ({ className, percent, small }) => {
  const containerClasses = classnames('flex-grow-1', styles.container, { [styles.small]: small }, className);

  return (
    <div className={containerClasses}>
      <div className={styles.baseline} />
      <div className={styles.bar} style={{ width: `${percent}%` }} />
    </div>
  );
};

Progress.propTypes = propTypes;

export default Progress;
